import { Navigate } from "react-router-dom"
import { useAuthContext } from "../hooks/useAuthContext"
import { useState, useEffect } from "react"

const Home = () => {
  const { user } = useAuthContext()
  const [home, setHome] = useState(undefined)

  useEffect(() => {
    console.log("user", user)
    if (user && user["role"] === "admin") {
      setHome("/user/connected-devices")
    }
    if (user && user["role"] === "operator") {
      setHome("/user/connected-devices")
    }
    if (user && user["role"] === "user") {
      setHome("/user/connected-devices")
    }
  }, [home, user])

  return home ? (
    <div>
      <Navigate to={home} />
    </div>
  ) : (
    <></>
  )
}

export default Home
